import { render, staticRenderFns } from "./CreateCredit.vue?vue&type=template&id=2e21e966&scoped=true"
import script from "./CreateCredit.vue?vue&type=script&lang=js"
export * from "./CreateCredit.vue?vue&type=script&lang=js"
import style0 from "./CreateCredit.vue?vue&type=style&index=0&id=2e21e966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e21e966",
  null
  
)

export default component.exports